/** Shared bits for the staff pages. */

export const ROLE_LABELS = {
    chef: 'Chef',
    cook: 'Cook',
    helper: 'Kitchen helper',
    packer: 'Packer',
    delivery: 'Delivery',
    manager: 'Manager',
    other: 'Other',
};

export const ROLE_OPTIONS = Object.entries(ROLE_LABELS)
    .map(([value, label]) => ({ value, label }));

export const ADJUSTMENT_KINDS = [
    { value: 'advance', label: 'Advance paid to staff', reduces: true },
    { value: 'deduction', label: 'Other deduction', reduces: true },
    { value: 'bonus', label: 'Bonus or incentive', reduces: false },
    { value: 'reimbursement', label: 'Reimbursement / extra payment', reduces: false },
];

export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];

/**
 * Full-precision rupees.
 *
 * Payroll figures are never abbreviated: "₹30.0K" is not an acceptable way to
 * show someone what they are being paid.
 */
export function money(value) {
    const number = Number(value || 0);
    return `₹${number.toLocaleString('en-IN', {
        minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function todayIso() {
    return new Date().toISOString().slice(0, 10);
}

/** "3 days", "1 day", "1.5 days" - trailing zeros dropped. */
export function dayCount(value) {
    const number = Number(value || 0);
    const text = Number.isInteger(number) ? String(number)
        : String(Number(number.toFixed(2)));
    return `${text} day${Math.abs(number) === 1 ? '' : 's'}`;
}

export const REQUEST_STATUS = {
    pending: { label: 'Waiting for approval', colour: 'warning' },
    approved: { label: 'Approved', colour: 'success' },
    rejected: { label: 'Not approved', colour: 'error' },
    withdrawn: { label: 'Withdrawn', colour: 'default' },
};

/** "10 Jun 2026", the way dates are written on a payslip. */
export function shortDate(value) {
    if (!value) return '';
    const date = new Date(`${value}T00:00:00`);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString('en-IN',
        { day: '2-digit', month: 'short', year: 'numeric' });
}

/** "10 Jun 2026" for a single day, "10 - 12 Jun 2026" for a range. */
export function dateRange(start, end) {
    if (!start) return '';
    if (!end || end === start) return shortDate(start);
    return `${shortDate(start)} to ${shortDate(end)}`;
}

/**
 * Download a file the API returns as a blob.
 *
 * It has to go through the API client rather than a plain link, because the
 * token lives in memory and a link would arrive unauthenticated.
 */
export function downloadBlob(response, fallbackName) {
    const disposition = response.headers['content-disposition'] || '';
    const match = disposition.match(/filename="?([^"]+)"?/);
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = match ? match[1] : fallbackName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}
